import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class AgendaLecture extends Resource {
  public static type = 'agenda_lectures';

  @prop
  public agendaId: number;

  @prop
  public lectureId: number;
}
